import { Mesh, Object3D } from 'three'
import { DoorPropsType, DrawerPropsType } from '../redux/cabinetReducer'
import { ShelvesPropsType } from './../redux/cabinetReducer'
import { createDivider, createSection } from './3DObjects'

export type DividerType = {
    type: 'none' | 'visible',
    top: number
    object: Mesh
    uuid: string
    // sections: {
    //     s1: Section,
    //     s2: Section
    // }
}

export type DividerPropsType = {
    type: 'none' | 'visible',
    top: number
    uuid: string
    // sections: {
    //     s1: SectionProps,
    //     s2: SectionProps
    // }
}

export type SectionProps = {
    name: string
    width: number
    height: number
    y: number
    dividersProps: DividerPropsType[]
    doorsProps: DoorPropsType[]
    drawersProps: DrawerPropsType[]
    shelvesProps: ShelvesPropsType[]

}

export const calculateCornerSectionSize = (width1: number, width2: number, depth1: number, depth2: number, thickness: number) => {
    //https://docs.google.com/drawings/d/1K7u-zPlLSAsqcnGt1ggNBfdGwkeSukW6IkEClD1JSj4/edit?usp=sharing

    const e1 = width2 - depth1 - thickness
    const e2 = width1 - depth2 - thickness
    const hyp = (e1 ** 2 + e2 ** 2) ** .5

    return hyp
}

export const calculateCornerSectionTransform = (width1: number, width2: number, depth1: number, depth2: number, thickness: number, forDoor = false, gap = 0.31369) => {
    //https://docs.google.com/drawings/d/1K7u-zPlLSAsqcnGt1ggNBfdGwkeSukW6IkEClD1JSj4/edit?usp=sharing

    const e1 = width2 - depth1 - thickness
    const e2 = width1 - depth2 - thickness
    const hyp = (e1 ** 2 + e2 ** 2) ** .5


    const angle = Math.asin(e2 / hyp)

    const x1 = thickness * e1 / e2
    const x2 = thickness * e2 / e1

    const _e1 = e1 + x1 + thickness
    const _e2 = e2 + x2 + thickness
    const _hyp = _e1 * hyp / e1// _hyp/hyp = _e1/e1

    const h = _e1 * _e2 / _hyp
    const z = h * _e1 / _e2 // z/e1 = h / e2 
    const y1 = x1 * hyp / e1 //y1/hyp = x1/e1

    const obj = new Object3D()
    obj.position.x = width2
    obj.position.z = width1
    obj.rotation.y = angle

    obj.translateZ(-h)
    obj.translateX((hyp / 2 - (z - y1)))

    if (forDoor)
        obj.translateZ(thickness / 2 + gap)

    return {
        x: obj.position.x,
        z: obj.position.z,
        angle
    }
}

export const makeSection = (props: SectionProps, thickness: number)
    : Section => new Section(
        props.name,
        props.width,
        props.height,
        props.y,
        props.dividersProps,
        thickness
    )

export default class Section {

    name: string
    width: number
    height: number
    y: number
    object: Object3D

    dividersProps: DividerPropsType[]
    dividers: DividerType[] = []

    sections: Section[] = []

    thickness: number

    // isCorner: boolean
    // angle: number
    // setSectionProps: (props: SectionProps) => void

    constructor(name: string, width: number, height: number, y: number, dividerProps: DividerPropsType[] = [], thickness: number) {
        this.name = name
        this.width = width
        this.height = height
        this.y = y
        this.thickness = thickness


        this.dividersProps = dividerProps.sort((a, b) => a.top - b.top) //sort by top 

        // this.setSectionProps = setSectionProps

        this.object = createSection(width, height)
        this.object.userData.type = 'section'
        this.object.name = name
        this.object.position.y = y
        // mesh.name = this.name



        this.splitSections()
        this.makeDividers()
        // if (dividerProps) {
        //     this.divider = this.setDivider(dividerProps.type, dividerProps.top)

        //     // if (this.divider){
        //     //     this.sc.add(this.divider.object)

        //     // }

        //     // this.splitSection()
        // }

    }

    makeDividers = () => {
        for (let i = 0; i < this.dividersProps.length; i++) {
            if (this.dividersProps[i].type === 'none')
                this.dividers.push({
                    type: 'none',
                    top: this.dividersProps[i].top,
                    object: createDivider(this.width),
                    uuid: this.dividersProps[i].uuid
                })
            else
                this.dividers.push({
                    type: 'visible',
                    top: this.dividersProps[i].top,
                    object: createDivider(this.width, this.thickness),
                    uuid: this.dividersProps[i].uuid
                })
        }

        for (let i = 0; i < this.dividers.length; i++) {
            this.dividers[i].object.name = (this.dividers[i].type === 'visible' ? 'v' : '') + `divider_${i + 1}`//_${i + 2}`
            this.dividers[i].object.position.y = this.height / 2 - this.dividers[i].top
        }
    }

    // setDivider = (type: 'none' | 'visible', top: number) => {

    //     if (this.dividerProps) {
    //         const s1Props = this.dividerProps.sections.s1
    //         const s2Props = this.dividerProps.sections.s2

    //         const divider = {
    //             type,
    //             top,
    //             object: createDivider(this.width),
    //             sections: {
    //                 s1: new Section(s1Props.name, s1Props.width, s1Props.height, s1Props.y, s1Props.dividerProps, this.setSectionProps),
    //                 s2: new Section(s2Props.name, s2Props.width, s2Props.height, s2Props.y, s2Props.dividerProps, this.setSectionProps),
    //             }
    //         }

    //         divider.object.name = this.name + '_divider'
    //         divider.object.position.y = this.y + this.height / 2 - top//this.height / 2 - top
    //         divider.object.position.z += .01

    //         // divider.sections.s1.object.position.z = this.object.position.z
    //         // divider.sections.s2.object.position.z = this.object.position.z

    //         // divider.sections.s1.object.position.y = this.object.position.y + this.height / 2 - divider.sections.s1.height / 2
    //         // divider.sections.s2.object.position.y = divider.sections.s1.object.position.y - divider.sections.s2.height / 2 - divider.sections.s1.height / 2

    //         return divider
    //     }

    // }

    splitSections = () => {
        // const tops = this.dividersProps.map(d => d.top)

        if (this.dividersProps.length > 0) {

            //Calculating sections heights
            const sHeights = [this.dividersProps[0].type === 'none' ? this.dividersProps[0].top : this.dividersProps[0].top - this.thickness / 2]

            for (let i = 1; i < this.dividersProps.length; i++) {
                const div = this.dividersProps[i]
                const prevDiv = this.dividersProps[i - 1]

                sHeights.push(
                    (div.type === 'none' ? div.top : div.top - this.thickness / 2) - (prevDiv.type === 'none' ? prevDiv.top : prevDiv.top + this.thickness / 2)
                )

                // sHeights.push(tops[i] - tops[i - 1])
            }

            sHeights.push(this.height - (
                this.dividersProps[this.dividersProps.length - 1].type === 'none'
                    ? this.dividersProps[this.dividersProps.length - 1].top
                    : this.dividersProps[this.dividersProps.length - 1].top + this.thickness / 2
            ))

            //Calculating sections position
            let sYs = [sHeights[0] / 2]

            for (let i = 1; i < this.dividersProps.length; i++) {
                sYs.push(
                    (this.dividersProps[i - 1].type === 'none' ? this.dividersProps[i - 1].top : this.dividersProps[i - 1].top + this.thickness / 2)
                    + sHeights[i] / 2
                )
            }

            sYs.push((
                this.dividersProps[this.dividersProps.length - 1].type === 'none'
                    ? this.dividersProps[this.dividersProps.length - 1].top
                    : this.dividersProps[this.dividersProps.length - 1].top + this.thickness / 2
            ) + sHeights[sHeights.length - 1] / 2)

            sYs = sYs.map(y => this.height / 2 - y)

            for (let i = 0; i < sHeights.length; i++) {
                this.sections.push(
                    new Section('section_' + (i + 1), this.width, sHeights[i], sYs[i], undefined, this.thickness)
                )
            }
        }
    }

    hideSection = (sectionNumber: number) => {
        let obj
        if (sectionNumber === 1 && this.sections.length === 0)
            obj = this.object
        else
            obj = this.sections.find(s => s.name.split('_')[1] === sectionNumber.toString())?.object

        // @ts-ignore
        obj.material.opacity = 0; obj.material.userData.hidden = true
    }

    showSection = (sectionNumber: number) => {
        let obj
        if (sectionNumber === 1 && this.sections.length === 1)
            obj = this.object
        else
            obj = this.sections.find(s => s.name.split('_')[1] === sectionNumber.toString())?.object

        // @ts-ignore
        obj.material.opacity = 0.6; obj.material.userData.hidden = false
    }
}